import { CarOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';
import { TaskType } from 'core/modules/tasks/task.interface';
import { useTranslation } from 'react-i18next';
import { eventStopPropagation } from 'src/utils/button';
import styled from 'styled-components';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var VALID_TYPES = [TaskType.Homologation, TaskType.Recognition];
export var TaskPlateNumberTag = function TaskPlateNumberTag(_ref) {
  var task = _ref.task;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (!VALID_TYPES.includes(task.content.type)) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  var content = task.content;

  if (!content.plateNumber) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: "".concat(t('form.carDetails.plateNumber.label'), ": ").concat(content.plateNumber),
      children: /*#__PURE__*/_jsx(Tag, {
        icon: /*#__PURE__*/_jsx(CarOutlined, {}),
        onClick: eventStopPropagation,
        children: content.plateNumber
      })
    }, "plateNumber")
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "PlateNumberTag__Container",
  componentId: "sc-14877bg-0"
})([".ant-tag{display:block;overflow:hidden;max-width:100px;padding-right:10px;text-overflow:ellipsis;}"]);